import React from "react";
import "./admin.css";

const SiteSettings = () => {
  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1>Site Settings</h1>
          <p>Configure system settings and preferences</p>
        </div>
      </div>

      <div className="content-stage">
        <div className="stage-text">
          <h2>Coming Soon</h2>
          <p>Site settings and configuration options will be available here.</p>
          <p style={{ marginTop: "16px", fontSize: "14px", opacity: 0.8 }}>
            This page will allow you to configure:
          </p>
          <ul style={{ textAlign: "left", marginTop: "12px", lineHeight: "1.8" }}>
            <li>Site branding and logos</li>
            <li>Email templates and notifications</li>
            <li>System-wide defaults</li>
            <li>Feature flags and toggles</li>
            <li>API integrations</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SiteSettings;
